@if (explain) {
<div class="cd">
    <!-- Coverage summary: the meter owns the covered/excluded ratio, stated once. -->
    <div class="cd-sum">
        <div class="cd-sum__top">
            <span class="cd-sum__lbl">Coverage</span>
            <span class="cd-sum__val">{{ coveragePercent }}%</span>
        </div>
        <div class="cd-meter">
            <span class="cd-meter__c" [style.flex]="coveredCircuits"></span>
            <span class="cd-meter__e" [style.flex]="excludedCircuits"></span>
        </div>
    </div>

    <!-- Orthogonal tiles: the source counts the meter does not carry. -->
    <div class="cd-stats">
        <div class="cd-stat">
            <span class="cd-stat__v">{{ explain.sourceCount }}</span>
            <span class="cd-stat__l">{{ explain.sourceCount === 1 ? 'Source' : 'Sources' }}</span>
        </div>
        <div class="cd-stat">
            <span class="cd-stat__v">{{ explain.excludedSourceCount }}</span>
            <span class="cd-stat__l">Excluded {{ explain.excludedSourceCount === 1 ? 'source' : 'sources' }}</span>
        </div>
    </div>

    <!-- Breakdown: the same list-table the flow-detail panel uses. An endpoint click shows a Source identity
         -> Source address tree; other clicks a flat endpoint list. The column header names the dimension, so
         no section label is needed. The State column merges the admission check with the verdict, and the
         leading checkbox includes/excludes the source (cascading on a parent). Hovering highlights the path. -->
    @if (rowData.length) {
    <div class="cd-tablewrap">
        <lib-list-table
            class="lt-skin"
            [tableId]="tableId"
            [options]="tableOptions"
            [columns]="columns"
            [childColumnsByLevel]="childColumnsByLevel"
            [treeVariant]="'flat'"
            [treeRail]="false"
            [rowData]="rowData"
            [totalCount]="rowData.length"
            [startCount]="1"
            [endCount]="rowData.length"
            [isLoading]="false"
            [filterApplied]="true"
            entityTypeName="rows"
            [showNoItemsAdd]="false"
            [noItemsReadonly]="true"
            (rowHover)="onRowHover($event)"
        ></lib-list-table>
    </div>
    }
</div>
}
